import { BrowserRouter, Routes as DOMRoutes, Route } from 'react-router-dom';
import { MainLayout } from '../layout/main';
import { routes } from './routes';
import { AppProvider } from './AppProvider';


export const Routes = () => {
  return (
    <AppProvider>
      <BrowserRouter>
        <DOMRoutes>
          <Route element={<MainLayout />}>
            {/* Public routes */}
            {routes.mainRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            
            {/* Protected routes within main layout */}
            {routes.protectedRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Route>

          {/* Standalone protected routes */}
          {routes.standaloneProtectedRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </DOMRoutes>
      </BrowserRouter>
    </AppProvider>
  );
};
